import axios from 'axios';
import { BASE_URL } from '../../constants/defaultValues';
import Dictionary from '../dictionary';

const { movement } = Dictionary;

const MovementService = {
  //  Fetch pending movement list
  getPendingList: async (paramsObj:{page:number,limit:number,search:string}) => {
    return axios.get(BASE_URL + movement.getPendingList(),{ params: paramsObj});
  },

  // POST: Fetch available barcodes
  getAvailableBarcodes: async (payload: {product_id:string}) => {
    return axios.post(BASE_URL + movement.getAvailableBarcodes(), payload);
  },

  // POST: Mark movement as delivered
  markAsDelivered: async (payload: {inventory_item_id:string,procurement_item_id:string}) => {
    return axios.post(BASE_URL + movement.markAsDelivered(), payload);
  },

  // Get processed procurement
  processProcurement: async (paramsObj:{page:number,limit:number,search:string}) => {
    return axios.get(BASE_URL + movement.processProcurement(),{ params: paramsObj});
  },

  //  Get delivered procurement
  markProcurementDelivered: async (paramsObj:{page:number,limit:number,search:string}) => {
    return axios.get(BASE_URL + movement.deliveredProcurement(),{ params: paramsObj});
  },

  //  Get cancelled procurement
  markProcurementCancelled: async (paramsObj:{page:number,limit:number,search:string}) => {
    return axios.get(BASE_URL + movement.getCancelledProcurement(),{ params: paramsObj});
  },

  //cancelled procurement
  cancelledProcurement:async (id:string)=>{
    return axios.delete(BASE_URL + movement.cancelledProcurement(id));
  },

  //  Get movement store list by ID
  getMovementStoreList: async (id: string) => {
    return axios.get(BASE_URL + movement.getMovementStoreList(id));
  },

  //Assign the store
  assignStore: async (payload:{pickup_store_id:string, procurement_item_id:string})=>{
    return axios.post(BASE_URL + movement?.assignStore(), payload)
  }
};

export default MovementService;
